import { render } from "./VisorCamara.vue?vue&type=template&id=2b9cffe9"
import script from "./VisorCamara.vue?vue&type=script&lang=js"
export * from "./VisorCamara.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__